import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { TagTheme } from '@fcom/ui-components';
import { Category } from '@fcom/dapi/api/models';
import { ServiceCatalogService } from '@fcom/dapi/interfaces';
import { getIconForServiceCategory } from '@fcom/dapi/utils';

import { hasProductInfoModal } from '../../../utils';

const CONSTITUENT_DETAILS_LINK_KEY: Partial<Record<Category, string>> = {
  [Category.MEAL]: 'ancillaries.seatMeal.detailsLinkTitle',
  [Category.PRIORITY]: 'ancillaries.seatPriority.detailsLinkTitle',
  [Category.CABIN_BAGGAGE]: 'ancillaries.seatCabinBaggage.detailsLinkTitle',
  [Category.LOUNGE]: 'ancillaries.lounge.detailsLinkTitle',
};

@Component({
  selector: 'fin-bundle-service-card',
  templateUrl: './bundle-service-card.component.html',
  styleUrls: ['./bundle-service-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BundleServiceCardComponent {
  @Input({ required: true }) service!: ServiceCatalogService;
  @Input() inCart = false;
  @Input() isTierBenefit = false;

  readonly TagTheme = TagTheme;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  modalOpen = false;

  get category(): Category {
    return this.service.category;
  }

  get icon(): SvgLibraryIcon {
    return getIconForServiceCategory(this.category);
  }

  get title(): string | null {
    return this.service.translations?.title ?? null;
  }

  get description(): string | null {
    return this.service.translations?.description ?? null;
  }

  get hasModal(): boolean {
    return hasProductInfoModal(this.category);
  }

  get detailsLinkKey(): string {
    return CONSTITUENT_DETAILS_LINK_KEY[this.category] ?? `ancillaries.${this.category}.detailsLinkTitle`;
  }
}
